import React from 'react';
import { Checkbox, CheckboxProps } from '@mui/material';
import './roundCheckbox.scss';

interface IRoundCheckboxProps extends Omit<CheckboxProps, 'classes'> {
  className?: string;
}

const RoundCheckbox = ({ className, ...props }: IRoundCheckboxProps) => {
  return (
    <Checkbox
      {...props}
      className={`roundCheckbox ${className || ''}`}
      disableRipple
      icon={<span className="roundCheckbox__icon" />}
      checkedIcon={<span className="roundCheckbox__icon roundCheckbox__icon--checked" />}
    />
  );
};

export default RoundCheckbox;
